module.exports = __webpack_public_path__ + "img/background.6cbfbcd3.png";